import { DxTagBoxTypes } from "devextreme-angular/ui/tag-box";
import DataSource from "devextreme/data/data_source";
import { el } from "src/app/support/dom";
import { TagLight } from "src/app/backend/models/tag/tag";
import { colorGetLighter, COLORS } from "src/app/support/colors";
import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { CreateTagFunctionService } from "src/app/modules/bootstrap/pms-ui/functions/tag/create-tag/create-tag-function.service";
import { compact, trim } from "lodash";
import { isFunction } from "radash";

type Input = {
  dxTagsDataSource: DataSource | undefined;
  placeholder?: string;
};

type Providers = {
  createTagFunctionService: CreateTagFunctionService | undefined;
};

type Options = {
  disableRemoveButton: boolean | (() => boolean);
};

export function dxTagBox(input: Input, providers: Providers, options: Options) {
  const tagTemplate = (tag: TagLight, tagElement: HTMLElement) => {
    const DEFAULT_COLOR = COLORS.CARCOAL_GRAY;
    const borderColor = tag.color || DEFAULT_COLOR;
    const textColor = colorGetLighter(tag.color || DEFAULT_COLOR, 85);
    const backgroundColor = tag.color || DEFAULT_COLOR;

    return el(
      "div",
      {
        class: trim(
          `dx-tag-content text-xs ${(isFunction(options?.disableRemoveButton) ? options.disableRemoveButton() : options.disableRemoveButton) ? "pr-[6px]" : ""}`
        ),
        style: {
          "background-color": backgroundColor,
          "border-width": "1px",
          "border-color": borderColor,
          "padding-left": "2px",
          "padding-right": "22px",
          "padding-top": "0",
          "padding-bottom": "0",
          "margin-top": "7px"
        }
      },
      compact([
        el(
          "span",
          {
            class: "text-xs font-bold",
            style: `color: ${textColor} !important;`
          },
          tag.name
        ),
        (
          isFunction(options?.disableRemoveButton)
            ? options.disableRemoveButton()
            : options.disableRemoveButton
        )
          ? null
          : el(
              "div",
              {
                class: "dx-tag-remove-button pms-tag-box"
              },
              [
                el("i", {
                  class: "fa-solid fa-xmark",
                  style: {
                    color: textColor,
                    "margin-top": "1px",
                    "margin-right": "3px"
                  }
                })
              ]
            )
      ])
    );
  };

  const onDxTagsCustomItemCreating = (
    dxEvent: DxTagBoxTypes.CustomItemCreatingEvent
  ) => {
    if (!dxEvent.text) {
      dxEvent.customItem = null;
      return;
    }

    dxEvent.component.close();

    dxEvent.customItem = new Promise(async (res) => {
      await providers.createTagFunctionService?.execute(
        {
          name: dxEvent.text
        },
        {
          createTagFn: async (data: any) => {
            dxEvent.customItem.name = data.name;
            dxEvent.customItem.color = data.color;

            const newTag = await input.dxTagsDataSource
              ?.store()
              .insert(dxEvent.customItem);

            await input.dxTagsDataSource?.reload();

            res(newTag);
          }
        }
      );
    });
  };

  return {
    displayExpr: "name",
    valueExpr: "id",
    searchEnabled: true,
    dataSource: input.dxTagsDataSource,
    acceptCustomValue: true,
    customItemCreateEvent: "",
    onCustomItemCreating: onDxTagsCustomItemCreating,
    placeholder: input.placeholder
      ? input.placeholder
      : sntTranslate(marker("Inizia a scrivere")),
    tagTemplate
  };
}
